import script from "./PointBox.vue?vue&type=script&setup=true&lang=js"
export * from "./PointBox.vue?vue&type=script&setup=true&lang=js"

import "./PointBox.vue?vue&type=style&index=0&id=2b325720&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b325720"]])

export default __exports__